import { requests } from 'api';
import { Gender } from './types';

const apiBaseUrl = '/api/genders';

export const GendersApi = {
  getAll: (): Promise<Gender[]> => requests.get(apiBaseUrl),
};
